import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const text = (theme: Theme) => css`
  flex: 1;
  align-items: center;
  padding-right: ${theme.spacing[8]};
`;
